// @module Cart
define('QuickAdd.View.LimitQty', [
  'QuickAdd.View',
  'Transaction.Line.Model',
  'Backbone',
  'underscore'
], function CartDetailedViewLimitQty(
  QuickAddView,
  TransactionLineModel,
  Backbone,
  _
) {
  'use strict';

  // @class Cart.Detailed.View This is the Shopping Cart view @extends Backbone.View
  return _.extend(QuickAddView.prototype, {

    saveForm: function saveForm(e) {
      var product;
      var selectedLine;
      e.preventDefault();

      Backbone.Validation.bind(this);

      this.model.set(this.$('form').serializeObject());

      product = this.model.get('selectedProduct');

      if (this.model.isValid(true) && product) {
        product.set('quantity', parseInt(this.model.get('quantity'), 10));
        selectedLine = new TransactionLineModel(product.toJSON());

        selectedLine.set('internalid', _.uniqueId('item_line'));
        selectedLine.set('item', product.getItem().clone());
        selectedLine.set('options', product.get('options').clone());

        // if the item is a matrix we add the parent so when saving the item in a product list (request a quote case)
        // we have the parent
        if (product.get('item').get('_matrixChilds').length) {
          selectedLine.get('item').set('_matrixParent', product.get('item'));
        }
        selectedLine.unset('selectedProduct');
        selectedLine.unset('quickaddSearch');

        // @event {QuickAdd.View.SelectedLine.Properties} selectedLine
        this.trigger(
          'selectedLine',
          // @class QuickAdd.View.SelectedLine.Properties
          {
            // @property {Transaction.Line.Model} selectedLine
            selectedLine: selectedLine
          }
        );
        // @class QuickAdd.View
        if (!this.qtyError) {
          this.$('[name="quantity"]').val('');
          this.$('[name="quantity"]').attr({
            min: 1
          });
          this.$('[data-type="quick-add-reset"]').hide();
          this.itemsSearcherComponent.cleanSearch();
          this.itemsSearcherComponent.setFocus();
        } else {
          this.$('[name="quantity"]').val(this.quantityAvailableToAdd);
          this.qtyError = false;
        }
      }
    }
  });
});
